module.exports = __webpack_public_path__ + "static/media/video-reflective-thinking-en.90ed3d16.vtt";